import { createContext } from "react";

export const OpportunitiesContext = createContext(null);